export default "__VITE_ASSET__DjEK3BrF__"